<template>
  <div class="skeleton-container d-flex align-items-center justify-content-between" :class="customClass">
    <div class="d-flex align-items-center">
      <p class="skeleton-image skeleton skeleton-light mr-2"></p>
      <div>
        <p class="skeleton-content skeleton-content-long skeleton skeleton-light"></p>
        <p class="skeleton-content skeleton-content-short skeleton skeleton-light mt-1"></p>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <p class="skeleton-status skeleton skeleton-light"></p>
      <p class="skeleton-checkbox skeleton skeleton-light mr-2 ml-1"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customClass: String,
  },
};
</script>

<style lang="scss" scoped>
  .skeleton {
    border-radius: 3px;
    &-container {
      border: solid 1px $light3;
      background-color: white;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
    &-image {
      width: 72px;
      height: 72px !important;
    }
    &-content {
      height: 17px !important;
      &-long {
        width: 300px !important;
      }
      &-short {
        width: 250px !important;
      }
    }
    &-status {
      width: 50px !important;
      height: 15px;
    }
    &-checkbox { 
      width: 20px !important;
      height: 20px !important;
    }
  }
</style>
